export default __webpack_public_path__ + "static/media/Reaper.35ad70ca.jpg";